import React from 'react';
import { Modal, Box, Typography, TextField, Button } from '@mui/material';

const ProjectCreateModal = ({
  projectModalOpen,
  setProjectModalOpen,
  newProjectName,
  setNewProjectName,
  handleAddProject
}) => (
  <Modal
    open={projectModalOpen}
    onClose={() => setProjectModalOpen(false)}
  >
    <Box sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      bgcolor: 'background.paper',
      boxShadow: 24,
      p: 4,
      borderRadius: 2,
      minWidth: 320
    }}>
      <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
        새 프로젝트 만들기
      </Typography>
      <TextField
        fullWidth
        label="프로젝트 이름"
        value={newProjectName}
        onChange={e => setNewProjectName(e.target.value)}
        sx={{ mb: 2 }}
        autoFocus
      />
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
        <Button onClick={() => setProjectModalOpen(false)} color="inherit">
          취소
        </Button>
        <Button variant="contained" onClick={handleAddProject} disabled={!newProjectName.trim()}>
          프로젝트 만들기
        </Button>
      </Box>
    </Box>
  </Modal>
);

export default ProjectCreateModal; 